import { Injectable } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { InvoiceData } from '@check-list/app/classes/models/invoice-data.model';
import { BehaviorSubject } from 'rxjs';
import { CertificateDialogComponent } from './certificate-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class CertificateDialogService {
  openedDialogs: BehaviorSubject<string[]> = new BehaviorSubject([]);

  constructor(private dialog: MatDialog) {}

  showInvoice(
    data: InvoiceData,
    readonly = false
  ): MatDialogRef<CertificateDialogComponent, void> {
    const dialogId = `${data.order.id} - ${data.subProject.name}`;
    let dialogRef = this.dialog.getDialogById(dialogId);

    if (dialogRef) {
      return this.restoreDialog(dialogId);
    }

    this.hideAllDialogs();

    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '950px';
    dialogConfig.disableClose = true;
    dialogConfig.closeOnNavigation = false;
    dialogConfig.hasBackdrop = false;

    dialogConfig.id = dialogId;
    dialogConfig.data = { ...data, readonly };

    this.openedDialogs.next([
      dialogConfig.id,
      ...this.openedDialogs.getValue()
    ]);

    dialogRef = this.dialog.open(CertificateDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(() => {
      const filtered = this.openedDialogs
        .getValue()
        .filter((id) => id !== dialogRef.id);

      this.openedDialogs.next(filtered);
    });

    return dialogRef;
  }

  hideDialog(id: string): void {
    const dialogRef = this.dialog.getDialogById(id);

    if (dialogRef) {
      dialogRef.addPanelClass('hidden');
    }
  }

  hideAllDialogs(): void {
    this.openedDialogs.getValue().forEach((id) => this.hideDialog(id));
  }

  restoreDialog(id: string): MatDialogRef<CertificateDialogComponent, void> {
    this.hideAllDialogs();
    const dialogRef = this.dialog.getDialogById(id);

    if (dialogRef) {
      dialogRef.removePanelClass('hidden');
    }

    return dialogRef;
  }
}
